import { render, staticRenderFns } from "./zhHk.vue?vue&type=template&id=0a5ee652&scoped=true&"
import script from "./zhHk.vue?vue&type=script&lang=ts&"
export * from "./zhHk.vue?vue&type=script&lang=ts&"
import style0 from "./zhHk.vue?vue&type=style&index=0&id=0a5ee652&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5ee652",
  null
  
)

export default component.exports